module.exports = __webpack_public_path__ + "e76c5456f24dc3ece6dac76dbbefe737.svg";